<template>
  <button
    @click="callback(label)"
    class="
      cursor-pointer
      ml-5
      text-xl
      capitalize
      transition-all
      duration-200
      ease-linear
      outline-none
      font-bold
      sm:ml-7
      md:ml-10
      py-2
    "
    :class="
      currentValue == label
        ? ' border-b-2 border-primaryLink text-primaryLink '
        : ' border-b-2 border-transparent text-gray-500'
    "
  >
    {{ label }}
  </button>
</template>

<script>
import store from '@/store';

export default {
  name: 'TabButtons',
  layout: 'admin',
  store,
  props: ['label', 'callback', 'currentValue'],
};
</script>
